import selectorConfig from './config.js';
import HeaderMylt from './HeaderNav/index.js';
import $ from 'jquery';
import ClubStore from 'framework/stores/ClubStore';
import ProfileStore from 'framework/stores/ProfileStore';
import ClubNavComponent from 'components/header-mylt/ClubNav';
import AccountFlyout from 'components/header-mylt/AccountFlyout';
import LoginLink from 'components/login-link';
import UrlStore from 'framework/stores/UrlStore';

var initialized = false;

function drawNav(club) {
	if(club && club.navHtml) {
		var fragment = $(club.navHtml);
		//update css from fragment
		$(selectorConfig.isCurrentClassName, fragment.find(selectorConfig.primaryNavContainer)).removeClass(selectorConfig.isCurrentClassName);
		//only get the content of primary navigation content
		var nav = $(fragment).find(selectorConfig.primaryNavContainer);
		$(selectorConfig.primaryNavContainer).replaceWith(nav);
		// replace the club nav
		var clubNav = fragment.find(selectorConfig.clubHeaderElement);
		$(selectorConfig.clubHeaderElement).replaceWith(clubNav);
		// replace the mobile logo/brand
		var mobileBrand = fragment.find(selectorConfig.mobileBrandContainer);
		$(selectorConfig.mobileBrandContainer).replaceWith(mobileBrand);
		// update club names
		$(selectorConfig.ltNavClubName).text(club.name);
	}
}

if($(selectorConfig.mainElement).length && $(selectorConfig.clubHeaderElement).length) {
	ClubStore.listen((club) => {
		if(!initialized && club.id) {
			// init the nav if there is a club loaded
			var header = new HeaderMylt(selectorConfig);
			var clubNav = new ClubNavComponent(ClubStore, UrlStore);
			var accountFlyout = new AccountFlyout(ProfileStore, UrlStore);
			var loginLink = new LoginLink(UrlStore);
			// detect hidden elements that only appear on author that don't depend on an event.
			var notAuthor = $('nav').find('lt-author').length === 0;
			if(!club.isClubPage && notAuthor) {
				drawNav(club);
			}
			clubNav.initialize();
			header.initialize(window);
			loginLink.initialize();
			accountFlyout.initialize();
			initialized = true;
		}
	});
}else if($(selectorConfig.mainElement).length) {
	var header = new HeaderMylt(selectorConfig);
	var accountFlyout = new AccountFlyout(ProfileStore, UrlStore);
	var loginLink = new LoginLink(UrlStore);
	header.initialize(window);
	loginLink.initialize();
	accountFlyout.initialize();
}

window.ef.analyticsService.handleFeedbackLink($('[class*="link_event_"]'));
